export const DATA_CENTRE = {
  codiCentre: "",
  nomCentre: "",
  coordX: "",
  coordY: "",
  labelFilter: "CODI_CENTER",
  labelNomFilter: "NOM_CENTER",
  typeAheadFlag: false,
  typeaheadMinLength: 1,
  readonly: false,
  hideValidation: true,
  inputGroupClass: ''
};

export const DATA_MUNICIPI = {
  codiMunicipi: "",
  nomMunicipi: "",
  bbox: "",
  labelFilter: "CODI_MUNICIPI",
  typeAheadFlag: false,
  readonly: false,
  hideValidation: true,
  inputGroupClass: ''
};

export const DATA_COMARCA = {
  codiComarca: "",
  nomComarca: "",
  bbox: "",
  labelFilter: "CODI_COMARCA",
  typeAheadFlag: false,
  readonly: false,
  hideValidation: true,
  inputGroupClass: ''
};

export const DATA_SERVEIS_TERRITORIAL = {
  codiServeiTerritorial: "",
  nomServeiTerritorial: "",
  bbox: "",
  labelFilter: "CODI_SERVEI_TERRITORIAL",
  typeAheadFlag: false,
  readonly: false,
  hideValidation: true,
  inputGroupClass: ''
};

export const DATA_DISTRICTE = {
  codiDistricte: "",
  nomDistricte: "",
  bbox: "",
  labelFilter: "CODI_DISTRICTE",
  typeAheadFlag: false,
  readonly: false,
  hideValidation: true,
  inputGroupClass: ''
};

export const DATA_LIST_CENTRES = {
  centres: [],
  totalItems: 0
};